import { render, staticRenderFns } from "./BuyBoxPromotionRowNew.vue?vue&type=template&id=42aa3d0e"
import script from "./BuyBoxPromotionRowNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxPromotionRowNew.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports